module.exports = __webpack_public_path__ + "img/05.a45ee710.jpg";